import React, {useContext, useEffect} from "react";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {PrintLabelContext} from "./context/PrintLabelContext";
import {PrintLabelSheetActions} from "./actions/PrintLabelSheetActions";

export const LabelSheetResponse = ({trackingIds}) => {
    const {printLabelModel, printLabelDispatch} = useContext(PrintLabelContext)

    useEffect(() => {
        printLabelDispatch({
            type: PrintLabelSheetActions.PRINT_LABEL_SHEET,
            data: {
                trackingIds: trackingIds,
                dispatcher: printLabelDispatch
            }
        })
    }, []);

    if (printLabelModel.errorOccurred && !printLabelModel.isLoading) {
        return (
            <Row alignmentHorizontal="center" alignmentVertical="center" height="100%">
                <Alert type="error">{printLabelModel.errorMessage}</Alert>
            </Row>
        );
    }
    return (<Box></Box>
    );
};


// WEBPACK FOOTER //
// ./src/components/labelSheet/LabelSheetResponse.js